import { useFeatureFlag } from '@crehana/feature-flags/react';
import { FEATURE_FLAGS_V5 } from "../../featureFlags";
import { useGetUserDataCentralized } from "./use-get-user-data-centralized";
export var useValidateShowMyTeamLearning = function useValidateShowMyTeamLearning() {
  var _useFeatureFlag = useFeatureFlag(FEATURE_FLAGS_V5.LEARNING_FOUNDATION_LIDER),
    isLearningFoundationLeaderEnabled = _useFeatureFlag.flagValue,
    loadingLearningFoundationLeader = _useFeatureFlag.loading;
  var _useGetUserDataCentra = useGetUserDataCentralized(),
    userIsFoundationLeader = _useGetUserDataCentra.userIsFoundationLeader,
    orgHasCentralized = _useGetUserDataCentra.orgHasCentralized,
    userIsFoundationSupervisor = _useGetUserDataCentra.userIsFoundationSupervisor,
    loadingGetUserDataCentralized = _useGetUserDataCentra.loading;
  var allowedByRoles = userIsFoundationLeader || userIsFoundationSupervisor;
  var shouldShowMyTeamLearning = Boolean(isLearningFoundationLeaderEnabled && allowedByRoles && orgHasCentralized);
  return {
    shouldShowMyTeamLearning: shouldShowMyTeamLearning,
    loading: loadingLearningFoundationLeader || loadingGetUserDataCentralized
  };
};